import { create } from "zustand";
import { persist } from "zustand/middleware";
import { GENERAL_INFO_FORM_PERSIST_KEY } from "../constants";

interface GeneralInfoFormState {
  operationId: string | null;
  waterConsumption: string;
  maxFeedRate: string;
  setValues: (operationId: string, waterConsumption: string, maxFeedRate: string) => void;
  reset: () => void;
}

/** DBCO-0059 (L4) - the Modify drawer's draft, kept per operation so a refresh does not lose what was typed. */
export const useGeneralInfoFormStore = create<GeneralInfoFormState>()(
  persist(
    (set) => ({
      operationId: null,
      waterConsumption: "",
      maxFeedRate: "",
      setValues: (operationId, waterConsumption, maxFeedRate) =>
        set({ operationId, waterConsumption, maxFeedRate }),
      reset: () => set({ operationId: null, waterConsumption: "", maxFeedRate: "" }),
    }),
    { name: GENERAL_INFO_FORM_PERSIST_KEY },
  ),
);
